/**
 * FURNITURE STORE — CUSTOM JS (GSAP-powered)
 * File: assets/furniture-shopify-custom.js
 * Requires: GSAP 3 + ScrollTrigger (loaded in theme.liquid <head>)
 */

(function () {
  'use strict';

  /* ── wait for GSAP to be available ─────────────────── */
  function waitForGSAP(cb) {
    if (typeof gsap !== 'undefined' && typeof ScrollTrigger !== 'undefined') {
      cb();
    } else {
      setTimeout(function () { waitForGSAP(cb); }, 50);
    }
  }

  /* ══════════════════════════════════════════════════════
     1. SCROLL PROGRESS BAR
  ══════════════════════════════════════════════════════ */
  function initScrollProgress() {
    var bar = document.createElement('div');
    bar.style.cssText = [
      'position:fixed','top:0','left:0','height:2px',
      'background:#B5965A','z-index:99999',
      'width:0','pointer-events:none',
      'transition:width 0.08s linear'
    ].join(';');
    document.body.appendChild(bar);
    window.addEventListener('scroll', function () {
      var total = document.documentElement.scrollHeight - window.innerHeight;
      bar.style.width = (total > 0 ? (window.scrollY / total * 100) : 0) + '%';
    }, { passive: true });
  }

  /* ══════════════════════════════════════════════════════
     2. STICKY HEADER SHADOW
  ══════════════════════════════════════════════════════ */
  function initStickyHeader() {
    var header = document.querySelector('header-component, .site-header, [data-section-type="header"]');
    if (!header) return;
    window.addEventListener('scroll', function () {
      header.style.boxShadow = window.scrollY > 60
        ? '0 2px 40px rgba(26,24,20,0.10)'
        : 'none';
    }, { passive: true });
  }

  /* ══════════════════════════════════════════════════════
     3. GSAP SCROLL ANIMATIONS
  ══════════════════════════════════════════════════════ */
  function initGSAPAnimations() {
    waitForGSAP(function () {

      /* ── HEADINGS ── */
      document.querySelectorAll(
        'h1:not(.furn-hero h1), h2, h3, h4, ' +
        '.furn-products__title, .furn-cats__title, ' +
        '.furn-split__title, .furn-testi__title, .furn-news__title, ' +
        '[class*="section__title"], [class*="collection__title"], ' +
        '[class*="heading"]:not([class*="card"])'
      ).forEach(function (el) {
        if (el.closest('.furn-hero')) return;
        gsap.from(el, {
          scrollTrigger: { trigger: el, start: 'top 88%', toggleActions: 'play none none none' },
          y: 42, opacity: 0, duration: 0.85, ease: 'power3.out'
        });
      });

      /* ── BODY TEXT ── */
      document.querySelectorAll(
        '.furn-split__text, .furn-testi-card__text, ' +
        '.furn-news__subtitle, [class*="rte"] p'
      ).forEach(function (el) {
        gsap.from(el, {
          scrollTrigger: { trigger: el, start: 'top 91%', toggleActions: 'play none none none' },
          y: 22, opacity: 0, duration: 0.75, delay: 0.12, ease: 'power2.out'
        });
      });

      /* ── PRODUCT CARDS — staggered scale+fade ── */
      document.querySelectorAll(
        '.furn-products__grid, [class*="product-grid"], .grid--products'
      ).forEach(function (grid) {
        var cards = Array.from(grid.children);
        if (!cards.length) return;
        gsap.from(cards, {
          scrollTrigger: { trigger: grid, start: 'top 86%', toggleActions: 'play none none none' },
          y: 55, opacity: 0, scale: 0.93,
          duration: 0.75, stagger: 0.10, ease: 'power3.out'
        });
      });

      /* ── CATEGORY CARDS ── */
      document.querySelectorAll('.furn-cats__grid').forEach(function (grid) {
        var cards = Array.from(grid.children);
        if (!cards.length) return;
        gsap.from(cards, {
          scrollTrigger: { trigger: grid, start: 'top 84%', toggleActions: 'play none none none' },
          y: 64, opacity: 0, scale: 0.91,
          duration: 0.82, stagger: 0.12, ease: 'expo.out'
        });
      });

      /* ── TESTIMONIAL CARDS ── */
      document.querySelectorAll('.furn-testi__grid').forEach(function (grid) {
        var cards = Array.from(grid.children);
        if (!cards.length) return;
        gsap.from(cards, {
          scrollTrigger: { trigger: grid, start: 'top 86%', toggleActions: 'play none none none' },
          y: 40, opacity: 0, scale: 0.96,
          duration: 0.7, stagger: 0.11, ease: 'power3.out'
        });
      });

      /* ── USP / FEATURE ITEMS ── */
      var uspItems = document.querySelectorAll('.usp-item, .furn-split__feature');
      if (uspItems.length) {
        gsap.from(Array.from(uspItems), {
          scrollTrigger: { trigger: uspItems[0].parentElement, start: 'top 87%', toggleActions: 'play none none none' },
          y: 32, opacity: 0, duration: 0.65, stagger: 0.09, ease: 'power2.out'
        });
      }

      /* ── STATS — scale punch ── */
      var statItems = document.querySelectorAll('.furn-stat-item, .stat-item');
      if (statItems.length) {
        gsap.from(Array.from(statItems), {
          scrollTrigger: { trigger: statItems[0].parentElement, start: 'top 88%', toggleActions: 'play none none none' },
          scale: 0.80, opacity: 0, duration: 0.7, stagger: 0.10, ease: 'back.out(1.8)'
        });
      }

      /* ── SPLIT SECTION — slide from sides ── */
      document.querySelectorAll('.furn-split').forEach(function (sec) {
        var img     = sec.querySelector('.furn-split__image');
        var content = sec.querySelector('.furn-split__content');
        if (img) gsap.from(img, {
          scrollTrigger: { trigger: sec, start: 'top 82%', toggleActions: 'play none none none' },
          x: -70, opacity: 0, duration: 1.0, ease: 'power3.out'
        });
        if (content) gsap.from(content, {
          scrollTrigger: { trigger: sec, start: 'top 82%', toggleActions: 'play none none none' },
          x: 70, opacity: 0, duration: 1.0, delay: 0.18, ease: 'power3.out'
        });
      });

      /* ── BUTTONS — scale pop ── */
      document.querySelectorAll(
        '.furn-hero__btn-primary, .furn-hero__btn-secondary, .furn-split__btn, .furn-news__btn'
      ).forEach(function (btn) {
        if (btn.closest('.furn-hero')) return;
        gsap.from(btn, {
          scrollTrigger: { trigger: btn, start: 'top 96%', toggleActions: 'play none none none' },
          scale: 0.85, opacity: 0, duration: 0.55, ease: 'back.out(2.2)'
        });
      });

      /* ── HORIZON NATIVE CARDS ── */
      document.querySelectorAll('.card-wrapper, [class*="product-item"]').forEach(function (card, i) {
        if (card.closest('.furn-products__grid')) return; // already handled above
        gsap.from(card, {
          scrollTrigger: { trigger: card, start: 'top 89%', toggleActions: 'play none none none' },
          y: 40, opacity: 0, scale: 0.95,
          duration: 0.7, delay: (i % 4) * 0.08, ease: 'power3.out'
        });
      });

      /* ── IMAGES / MEDIA ── */
      document.querySelectorAll('.furn-product-card__media, [class*="card__media"]').forEach(function (el) {
        gsap.from(el, {
          scrollTrigger: { trigger: el, start: 'top 93%', toggleActions: 'play none none none' },
          scale: 0.95, opacity: 0, duration: 0.7, ease: 'power2.out'
        });
      });

    }); // end waitForGSAP
  }

  /* ══════════════════════════════════════════════════════
     4. ANIMATED COUNTERS
  ══════════════════════════════════════════════════════ */
  function initCounters() {
    waitForGSAP(function () {
      document.querySelectorAll('[data-count]').forEach(function (el) {
        var target = parseFloat(el.dataset.count) || 0;
        var suffix = el.dataset.suffix || '';
        var obj    = { val: 0 };
        gsap.to(obj, {
          scrollTrigger: { trigger: el, start: 'top 86%', toggleActions: 'play none none none' },
          val: target, duration: 2.2, ease: 'power2.out',
          onUpdate: function () { el.textContent = Math.round(obj.val) + suffix; }
        });
      });
    });
  }

  /* ══════════════════════════════════════════════════════
     5. CARD HOVER — magnetic lift
  ══════════════════════════════════════════════════════ */
  function initCardHover() {
    function attach(card) {
      if (card.dataset.hi) return;
      card.dataset.hi = '1';
      card.addEventListener('mouseenter', function () {
        gsap.to(card, { y: -10, scale: 1.02, duration: 0.4, ease: 'power2.out',
          boxShadow: '0 24px 60px rgba(26,24,20,0.14)' });
      });
      card.addEventListener('mouseleave', function () {
        gsap.to(card, { y: 0, scale: 1, duration: 0.4, ease: 'power2.inOut',
          boxShadow: '0 0px 0px rgba(26,24,20,0)' });
      });
    }
    document.querySelectorAll(
      '.furn-product-card, .furn-cat-card, .card-wrapper, .product-card'
    ).forEach(attach);

    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (n) {
          if (n.nodeType !== 1) return;
          if (n.querySelectorAll) n.querySelectorAll('.card-wrapper, .furn-product-card').forEach(attach);
          if (n.matches && n.matches('.card-wrapper, .furn-product-card')) attach(n);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }

  /* ══════════════════════════════════════════════════════
     6. BUTTON RIPPLE
  ══════════════════════════════════════════════════════ */
  function initRipple() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('.furn-hero__btn-primary,.furn-split__btn,.furn-news__btn,.btn,.button,[type="submit"]');
      if (!btn) return;
      var ripple = document.createElement('span');
      var rect   = btn.getBoundingClientRect();
      var size   = Math.max(rect.width, rect.height) * 1.6;
      ripple.style.cssText = [
        'position:absolute','border-radius:50%',
        'background:rgba(255,255,255,0.22)','pointer-events:none',
        'width:'+size+'px','height:'+size+'px',
        'top:'+(e.clientY-rect.top-size/2)+'px',
        'left:'+(e.clientX-rect.left-size/2)+'px',
        'transform:scale(0)','z-index:10'
      ].join(';');
      if (getComputedStyle(btn).position === 'static') btn.style.position = 'relative';
      btn.style.overflow = 'hidden';
      btn.appendChild(ripple);
      waitForGSAP(function () {
        gsap.to(ripple, { scale: 1, opacity: 0, duration: 0.55, ease: 'power2.out',
          onComplete: function () { ripple.remove(); } });
      });
    });
  }

  /* ══════════════════════════════════════════════════════
     7. PARALLAX
  ══════════════════════════════════════════════════════ */
  function initParallax() {
    if (window.innerWidth < 768) return;
    waitForGSAP(function () {
      var heroImg = document.querySelector('.furn-hero__bg img');
      if (heroImg) {
        gsap.to(heroImg, {
          scrollTrigger: { trigger: '.furn-hero', start: 'top top', end: 'bottom top', scrub: 1.5 },
          scale: 1.14, ease: 'none'
        });
      }
      document.querySelectorAll('.furn-split__image img').forEach(function (img) {
        gsap.to(img, {
          scrollTrigger: {
            trigger: img.closest('.furn-split'),
            start: 'top bottom', end: 'bottom top', scrub: 1.2
          },
          y: -44, ease: 'none'
        });
      });
    });
  }

  /* ══════════════════════════════════════════════════════
     8. MARQUEE CLONE
  ══════════════════════════════════════════════════════ */
  function initMarquee() {
    document.querySelectorAll('.furn-marquee__track').forEach(function (t) {
      t.innerHTML += t.innerHTML;
    });
  }

  /* ══════════════════════════════════════════════════════
     9. SMOOTH IMAGE LOAD
  ══════════════════════════════════════════════════════ */
  function initImageFade() {
    document.querySelectorAll('img[loading="lazy"]').forEach(function (img) {
      img.style.cssText = 'opacity:0;transition:opacity 0.55s ease';
      img.addEventListener('load', function () { img.style.opacity = '1'; });
      if (img.complete) img.style.opacity = '1';
    });
  }

  /* ══════════════════════════════════════════════════════
     10. ZERO GAP RUNTIME FIX
  ══════════════════════════════════════════════════════ */
  function fixGaps() {
    document.querySelectorAll('.shopify-section').forEach(function (s) {
      s.style.marginTop = '0';
      s.style.marginBottom = '0';
    });
  }

  /* ══════════════════════════════════════════════════════
     11. MONTSERRAT RUNTIME ENFORCE
  ══════════════════════════════════════════════════════ */
  function enforceMontserrat() {
    if (document.getElementById('montserrat-override')) return;
    var s = document.createElement('style');
    s.id = 'montserrat-override';
    s.textContent = "* { font-family: 'Montserrat', sans-serif !important; }";
    document.head.appendChild(s);
  }

  /* ══════════════════════════════════════════════════════
     INIT
  ══════════════════════════════════════════════════════ */
  function init() {
    enforceMontserrat();
    initScrollProgress();
    initStickyHeader();
    initMarquee();
    initImageFade();

    function onReady() {
      fixGaps();
      initGSAPAnimations();
      initCounters();
      initCardHover();
      initRipple();
      initParallax();
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', onReady);
    } else {
      onReady();
    }
  }

  init();
})();
